var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mainMenu" }, [
    _c(
      "div",
      { staticClass: "left-bar" },
      [
        _vm._m(0),
        _vm._l(_vm.aside, function(item, index) {
          return _c(
            "span",
            {
              key: index,
              staticClass: "item",
              on: {
                click: function($event) {
                  return _vm.handleItem(index)
                }
              }
            },
            [
              _c("span", { staticClass: "bgBlock" }),
              _c("span", { staticClass: "title-wrap" }, [
                _c("i", { class: item.icon }),
                _c("span", [_vm._v(_vm._s(item.titleName))])
              ])
            ]
          )
        })
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "menu-wrap" },
      [
        _c("div", { staticClass: "title-wrap" }, [
          _c("div", { attrs: { id: "menuTitle" } }, [
            _vm._v(_vm._s(_vm.$t("MainMenu.title")))
          ]),
          _c("div", { staticClass: "version" }, [
            _c("span", [_vm._v("v " + _vm._s(_vm.$packageInfo.version))])
          ]),
          _c("div", { staticClass: "subTitle" }, [
            _c("span", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.currentFirstName))
            ]),
            _c("span", { staticClass: "line" })
          ])
        ]),
        _c(
          "el-menu",
          {
            attrs: { "default-active": _vm.fullPath },
            on: { select: _vm.handleMenuSelect }
          },
          [
            _vm._l(_vm.menuList, function(item, index) {
              return [
                item.children
                  ? _c(
                      "el-submenu",
                      { key: index, attrs: { index: item.path } },
                      [
                        _c("template", { slot: "title" }, [
                          _c("span", [_vm._v(_vm._s(item.titleName))])
                        ]),
                        _vm._l(item.children, function(subItem, subindex) {
                          return _c(
                            "el-menu-item-group",
                            { key: subindex },
                            [
                              _c(
                                "el-menu-item",
                                {
                                  key: subindex,
                                  attrs: { index: subItem.path }
                                },
                                [_vm._v(_vm._s(subItem.title))]
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  : _c(
                      "el-menu-item",
                      { key: index, attrs: { index: item.path } },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "title" }, slot: "title" },
                          [_vm._v(_vm._s(item.titleName))]
                        )
                      ]
                    )
              ]
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-warp" }, [
      _c("img", { attrs: { src: require("@/assets/image/logo.jpg"), alt: "" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }